import skrollTop from 'skrollTop';
import './easings';
import {getOffset} from './_getOffset';

export function scrollSnap() {
  const scrollSnapContainer = document.querySelectorAll('.js-scroll-snap-container');
  if(scrollSnapContainer) {
    for (let i = 0; i < scrollSnapContainer.length; i++) {
      const _scrollSnapContainer = scrollSnapContainer[i];
      const scrollSnap = _scrollSnapContainer.querySelectorAll('.js-scroll-snap');
      const minusEl = document.querySelectorAll('.js-scroll-minus-el');
      let scrollSnapArr = '';
      let wh = '';
      let vh = '';
      let scrollSnapFirstHeight = '';
      let containerBottom = '';

      if(!IS_TOUCH && scrollSnap.length > 0) {
        const SCROLL_TOP_POSITION = function() {
          scrollSnapArr = new Array;
          let minusElHeight = 0;
          if(minusEl) {
            for (let i = 0; i < minusEl.length; i++) {
              const el = minusEl[i];
              minusElHeight += el.offsetHeight;
            }
          }
          for (let i = 0; i < scrollSnap.length; i++) {
            const target = scrollSnap[i];
            const targetScrollOffset = getOffset(target);
            const targetscrollSnap = targetScrollOffset.top - minusElHeight;
            const targetScrollBottom = targetscrollSnap + target.offsetHeight + minusElHeight;
            scrollSnapArr[i] = [targetscrollSnap, targetScrollBottom];
            if(i == 0) scrollSnapFirstHeight = target.offsetHeight;
          }
          wh = window.innerHeight
          vh = wh - minusElHeight;

          const containerHeight = _scrollSnapContainer.offsetHeight;
          containerBottom = containerHeight + minusElHeight
        }

        const SCROLL_POSITION_CHECK = function() {
          const scTop = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
          const scBottom = scTop + wh;
          const arrLength = scrollSnapArr.length;
          for (let i = 0; i < scrollSnap.length; i++) {
            const target = scrollSnap[i];
            target.classList.remove('is-current');
            target.classList.add('is-hidden');
          }
          for (let i = 0; i < scrollSnapArr.length; i++) {
            const thisArr = scrollSnapArr[i];
            const thisScrollTop = thisArr[0];
            const thisScrollBottom = thisArr[1];
            if(thisScrollTop < scTop && thisScrollBottom > scTop || thisScrollTop == scTop) {
              const currentMiddle = (thisScrollTop+thisScrollBottom)/2;
              if(currentMiddle < scTop && arrLength > (i + 1)) {
                const _i = i + 1;
                const currentArr = scrollSnapArr[_i];
                const currentScrollTop = currentArr[0];
                const currentElement = scrollSnap[_i];
                currentElement.classList.remove('is-hidden');
                currentElement.classList.add('is-current');
                if(vh >= scrollSnapFirstHeight && containerBottom >= scBottom) {
                  skrollTop.stop();
                  document.body.classList.add('is-scrolling');
                  skrollTop.scrollTo({
                    to: currentScrollTop,
                    easing: window.easings.easeInOutQuart,
                    duration: 400,
                    callback: () => { document.body.classList.remove('is-scrolling') }
                  });
                }
              } else if(currentMiddle > scTop) {
                const _i = i;
                const currentArr = scrollSnapArr[_i];
                const currentScrollTop = currentArr[0];
                const currentElement = scrollSnap[_i];
                currentElement.classList.remove('is-hidden');
                currentElement.classList.add('is-current');
                if(vh >= scrollSnapFirstHeight && containerBottom >= scBottom) {
                  skrollTop.stop();
                  document.body.classList.add('is-scrolling');
                  skrollTop.scrollTo({
                    to: currentScrollTop,
                    easing: window.easings.easeInOutQuart,
                    duration: 400,
                    callback: () => { document.body.classList.remove('is-scrolling') }
                  });
                }
              }
            }
          }
        }

        window.addEventListener('resize', () => {
          SCROLL_TOP_POSITION();
          SCROLL_POSITION_CHECK();
        });

        window.addEventListener('orientationchange', () => {
          SCROLL_TOP_POSITION();
          SCROLL_POSITION_CHECK();
        });

        let timeoutId = '';
        window.addEventListener('wheel', (e) => {
          clearTimeout(timeoutId);
          document.body.classList.remove('is-scrolling');
          skrollTop.stop();
          if(!document.body.classList.contains('is-scrolling')) {
            timeoutId = setTimeout(() => {
              SCROLL_POSITION_CHECK();
            }, 50);
          } else {
            e.preventDefault();
          }
        });

        
        window.addEventListener('scroll', () => {
          clearTimeout(timeoutId);
          if(!document.body.classList.contains('is-scrolling')) {
            timeoutId = setTimeout(() => {
              SCROLL_POSITION_CHECK();
            }, 50);
          }
        });

        setTimeout(() => {
          SCROLL_TOP_POSITION();
          SCROLL_POSITION_CHECK();
        }, 1000);

      }
    }
  }
}